import { motion } from "framer-motion";
import { IMG } from "../data/content";
import { SectionLabel } from "./Section";
import { fadeUp, stagger, viewport } from "../lib/motion";

const VIBES = [
  "Warm, light-filled atmosphere",
  "Comfortable indoor seating",
  "Friends meeting over coffee",
  "Students & remote workers",
  "Professionals on the go",
  "Unhurried weekend brunch",
];

const CustomerExperience = () => (
  <section className="relative py-16 sm:py-32 bg-primary text-background overflow-hidden" data-testid="experience-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <SectionLabel className="text-highlight">Customer Experience</SectionLabel>
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] text-background"
          >
            The kind of place you <span className="text-highlight">never want to leave.</span>
          </motion.h2>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="mt-6 text-background/80 text-base sm:text-lg leading-relaxed max-w-lg"
          >
            From the first pour of the morning to the last light of the evening, Detour is built for lingering — good coffee, warm faces, and a space that feels like home.
          </motion.p>

          <motion.ul
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3.5"
          >
            {VIBES.map((v) => (
              <motion.li key={v} variants={fadeUp} className="flex items-center gap-3 text-background/90">
                <span className="h-1.5 w-1.5 rounded-full bg-highlight shrink-0" />
                <span className="text-sm sm:text-base">{v}</span>
              </motion.li>
            ))}
          </motion.ul>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="grid grid-cols-2 gap-4"
        >
          <motion.div variants={fadeUp} className="overflow-hidden rounded-3xl shadow-warm-lg mt-10">
            <img src={IMG.interiorRoom} alt="Detour café seating" loading="lazy" className="h-full w-full object-cover aspect-[3/4] hover:scale-105 transition-transform duration-700" />
          </motion.div>
          <motion.div variants={fadeUp} className="overflow-hidden rounded-3xl shadow-warm-lg">
            <img src={IMG.detourWall} alt="The Detour wall" loading="lazy" className="h-full w-full object-cover aspect-[3/4] hover:scale-105 transition-transform duration-700" />
          </motion.div>
          <motion.div variants={fadeUp} className="overflow-hidden rounded-3xl shadow-warm-lg col-span-2">
            <img src={IMG.interiorBar} alt="The bar at Detour" loading="lazy" className="h-full w-full object-cover aspect-[16/9] hover:scale-105 transition-transform duration-700" />
          </motion.div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default CustomerExperience;
